// V1.5+ Signal Surge — a brief mid-match capture-acceleration window.
//
// V2 Tempo patch (2026-05-24) — moved from 5:30 to 2:30.
// CrazyGames analytics showed avg playtime at 3m09s with players bouncing
// before any sim-side spectacle. The old 5:30 surge fired AFTER the
// average player had already left. New 2:30 surge fires DURING the
// quit-decision window — the green "SIGNAL SURGE!" banner, doubled
// capture speed, and forced action become the first big "wow" moment
// rather than a feature most players never saw.
//
// A 20-second window starting at 2:30 (`SIGNAL_SURGE_START_SEC = 150`
// → 170) where capture progress accelerates ×
// `SIGNAL_SURGE_CAPTURE_SPEED_MULT` (2.0). The dynamic the surge creates:
//   - The trailing player gets a commit window: capture a contested
//     relay in ~5 s instead of ~10 s.
//   - The leading player must defend more aggressively — the safest
//     strategy can't be "park a Recon and hope the timer runs out".
//   - It's a SHORT window, so it forces the decision to be made now,
//     not deferred.
//
// Stack-up with Signal Storm:
//   Surge is OVER before the Storm starts (170 s < 300 s), so they
//   never overlap. If a future tuning pass moves the surge later, the
//   `if (state.phase === 'signal_storm') ratePerSec *= STORM_MULT`
//   inside CaptureSystem already composes — surge would apply OUTSIDE
//   the storm check, multiplicatively.
//
// Engineer 50% bonus composes multiplicatively (Engineer in surge =
// 1.5 × 2.0 = 3.0× capture rate — a clear payoff for the player who
// has built an Engineer and survived to 2:30).
//
// V1.5+ §17 anti-turtling consideration:
//   The surge is symmetric — both players get the 2× rate at the same
//   time. It creates action, not asymmetric advantage. The trailing
//   player benefits MORE because they have more relays to flip (they
//   don't yet hold most of them), so the surge is a soft comeback
//   lever similar to Underdog Surge but mechanical instead of
//   economic.
export const SIGNAL_SURGE_START_SEC = 150;
export const SIGNAL_SURGE_DURATION_SEC = 20;
export const SIGNAL_SURGE_END_SEC = SIGNAL_SURGE_START_SEC + SIGNAL_SURGE_DURATION_SEC;
export const SIGNAL_SURGE_CAPTURE_SPEED_MULT = 2.0;

// Convenience predicate. Used by CaptureSystem and the HUD banner.
export function isSignalSurgeActive(matchSeconds: number): boolean {
  return matchSeconds >= SIGNAL_SURGE_START_SEC && matchSeconds < SIGNAL_SURGE_END_SEC;
}
